import script from "./BulkRegisterResultModalContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkRegisterResultModalContent.vue?vue&type=script&setup=true&lang=ts"

import "./BulkRegisterResultModalContent.vue?vue&type=style&index=0&id=49f21bd1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49f21bd1"]])

export default __exports__